import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/auth.service';
// import { AuthfakeauthenticationService } from '../services/authfake.service';

import { environment } from '../../../environments/environment';
import { AuthmongoService } from '../services/authmongo.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    // private authfackservice: AuthfakeauthenticationService,
    private authMongo: AuthmongoService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    console.log(environment.defaultauth);

    if (environment.defaultauth === 'firebase') {

      const currentUser = this.authenticationService.currentUser();

      
      if (currentUser && currentUser.token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser.token}`,
          },
        });
      }
    } else {
      // add authorization header with jwt token if available
      // const currentUser = this.authfackservice.currentUserValue;
      const currentUser = this.authMongo.currentUserValue;
      if (currentUser && currentUser.token) {
        request = request.clone({
          setHeaders: {
            // Authorization: `Bearer ${currentUser.token}`
            'x-auth-token': currentUser.token,
            'x-request-id': '',
            'x-b3-traceid': '',
            'x-b3-spanid': '',
            'x-b3-parentspanid': '',
            'x-b3-sampled': '',
            'x-b3-flags': '',
            'x-ot-span-context': '',
            'x-dev-user': '',
            fail: '',
            'x-cloud-trace-context': '',
            traceparent: '',
            'grpc-trace-bin': '',
          },
        });
      }
    }
    return next.handle(request);
  }
}
